import { IconProps } from "./types";

export function SendIcon(props: IconProps) {
  const { color = "currentColor", size = 16, ...otherProps } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" {...otherProps}>
      <path
        d="M17.3187 2.68104C17.2344 2.59709 17.1278 2.53896 17.0116 2.5135C16.8953 2.48803 16.7742 2.49629 16.6625 2.53729L2.9125 7.53729C2.79392 7.58227 2.69183 7.66226 2.61978 7.76664C2.54774 7.87102 2.50916 7.99484 2.50916 8.12167C2.50916 8.2485 2.54774 8.37232 2.61978 8.4767C2.69183 8.58108 2.79392 8.66107 2.9125 8.70604L8.28125 10.8498L12.2438 6.8748L13.125 7.75604L9.14375 11.7373L11.2938 17.106C11.3401 17.2223 11.4202 17.322 11.5239 17.3922C11.6275 17.4624 11.7498 17.4999 11.875 17.4998C12.0013 17.4972 12.1239 17.4564 12.2265 17.3828C12.3292 17.3091 12.4071 17.2061 12.45 17.0873L17.45 3.3373C17.4926 3.22672 17.5029 3.10631 17.4796 2.99012C17.4564 2.87393 17.4006 2.76674 17.3187 2.68104Z"
        fill={color}
      />
    </svg>
  );
}
